<template>
	<div id="app"
		@keyup.esc="showSystem(false)"
		@keyup.enter="showSystem(true)"
		tabindex="0">

		<!-- PRELOADER -->
		<!-- <preloader
			v-if="preloading && manifest"
			:manifest="manifest">
		</preloader> -->

		<!-- ROUTER VIEW -->
		<router-view @request-preloader="preload" />

		<!-- SCREEN RESTRICT -->
		<div class="screen-restrict">
			<h2>Your screen is too small.<br><i class="fa fa-long-arrow-left"></i>&nbsp;<i class="fa fa-frown-o fa-spin"></i>&nbsp;<i class="fa fa-long-arrow-right"></i></h2>
		</div>

	</div>
</template>

<script>
    import { mapActions } from 'vuex';
    import Preloader from './components/Preloader';

    export default {
        components: {
            Preloader: Preloader
        },
        data(){
            return {
                preloading: null, // true
                manifest: null,
            }
        },
        methods: {
            ...mapActions('gameOS', [
                'showSystem'
            ]),
            preload(event) {
            	this.manifest = event.manifest;
                this.preloading = true; // temporaily disabling
                // console.log(event.manifest + ' preloading true');
            },
        }
    }
</script>

<style lang="scss">

	@import '~animate.css/animate.css';
	@import "~@/assets/scss/bootstrap/bootstrap";
	@import '~@/assets/scss/app/fonts';
	@import "~@/assets/scss/liquidvisual/components/custom";

	[v-cloak] {
	    display: none;
	}

	//-----------------------------------------------------------------
	// BROWSER
	//-----------------------------------------------------------------

	html {
		overflow: hidden; // [LOCKED] - stop Chrome touchpad wobble
	}

	//-----------------------------------------------------------------
	// FONT SMOOTHING
	//-----------------------------------------------------------------

	body {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		font-smoothing: antialised;
	}

	//-----------------------------------------------------------------
	// SELECTION
	//-----------------------------------------------------------------

	::selection {
		background: lighten($primary, 10%);
		color: white;
		text-shadow: none;
	}

	button {
		cursor: default !important;
	}

	*:not(input, textarea) {
		outline: 0 !important;
		cursor: default;

		// figure out better way - collision with inputs
		-webkit-touch-callout: none;
		user-select: none;
	}

	//-----------------------------------------------------------------
	// APP
	//-----------------------------------------------------------------

	#app {
	    position: fixed; // [LOCKED] - prevents jumping
	    top: 0;
	    left: 0;
	    width: 100%;
	    height: 100%;
	    min-width: 1024px;
	}

	//-----------------------------------------------------------------
	// SCROLLBARS
	//-----------------------------------------------------------------

	.kleptos-overflow {
		overflow: auto; // default
	}

	/* this targets the default scrollbar (compulsory) */
	.kleptos-overflow::-webkit-scrollbar {
		width: 14px;
		height: 14px;
	}

	// vertical
	.kleptos-overflow::-webkit-scrollbar-track:vertical {
		background: rgba(black, 0.1); //#ebece3
	}

	// horizontal
	.kleptos-overflow::-webkit-scrollbar-track:horizontal {
		background: rgba(black, 0.1);
	}

	/* this will style the thumb, ignoring the track */
	.kleptos-overflow::-webkit-scrollbar-thumb {
		box-sizing: content-box;
		border: 1px solid rgba(white, 0.6);
		border-right: 1px solid rgba(black, 0.2);
		border-bottom: 1px solid rgba(black, 0.2);
		background-color: rgba(#b3b2a5, 0.8); //rgba(0, 0, 0, 0.2);
	}

	/* optionally, you can style the top and the bottom buttons (left and right for horizontal bars) */
	.kleptos-overflow::-webkit-scrollbar-button {
		display: none; // windows only
	}

	/* if both the vertical and the horizontal bars appear, then perhaps the right bottom corner also needs to be styled */
	.kleptos-overflow::-webkit-scrollbar-corner {
		background: rgba(black, 0.15);
	}

	.theme-os {
		/* this will style the thumb, ignoring the track */
		.kleptos-overflow::-webkit-scrollbar-thumb {
			background-color: lighten(black, 30%); //rgba(0, 0, 0, 0.2);
			border: 1px solid transparent;
			border-right: none;
			border-bottom: none;
		}
	}

	//-----------------------------------------------------------------
	// SCREEN RESTRICT
	//-----------------------------------------------------------------

	.screen-restrict {
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: black;
		font-family: 'Avenir Next';
		text-align: center;
		color: white;
		z-index: 2147483647; // [LOCKED] - highest possible

		@media (min-width: 1024px) {
			display: none;
		}

		h2 {
			font-size: rem-calc(22);
			font-weight: 600;
		}

		.fa {
			color: #e31325;
		}
	}

</style>